import DiagnosticCard from './Diagnostics'

const ChatDiagnosticsModal = ({
  diagOpen,
  productRoutineOpen,
  productsReady,
  productRoutineReady,
  productRoutineData,
  selectedProduct,
  diagnosticRequestData,
  onClose,
}) => {
  return (
    <DiagnosticCard
      isOpen={diagOpen || productRoutineOpen}
      onClose={onClose}
      productsReady={productsReady || productRoutineReady}
      mode={productRoutineOpen ? 'productRoutine' : 'diagnostics'}
      routineData={productRoutineData}
      selectedProduct={selectedProduct}
      diagnosticRequestData={diagnosticRequestData}
      routineText={productRoutineData}
      showRoutineAdvice={productRoutineReady}
    />
  )
}

export default ChatDiagnosticsModal